import React from 'react';

interface CheckBoxProps {
  className?: string;
}

export const CheckBox = ({ className }: CheckBoxProps) => (
  <div className={className}>
    <CheckMark />
  </div>
);

export const CheckMark = () => (
  <svg width="16" height="16" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M 2.2808 6.5114 L 5.1884 9.6219 L 10 4.1"
      stroke="var(--checkbox-checked-arrow-color)"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
